// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles co-localises de l'onglet Candidature commande-MS (V2). Copie autonome (PAS un import)
   des regles techniques/financieres de l'oracle Candidature.css : memes classes, memes valeurs,
   pour une parite visuelle exacte. Les classes .section-header / .section-content / .form-group /
   .input-inactif / .action-buttons / .error-message / .required / .page-break viennent du global
   App.css (toujours charge). */

.tab-candidature {
  display: flex;
  flex-direction: column;
}

/* Bandeau d'expiration : encadre rouge proeminent (reproduit le style inline de l'oracle
   Candidature.tsx:751-763, ici en classe co-localisee). */
.tab-candidature .expired-notice {
  background-color: #fee;
  border: 2px solid #c33;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  color: #c33;
  font-weight: bold;
  text-align: center;
}

/* --- Descriptif technique : reponse + criteres ---------------------------- */
.definition-besoin-textarea {
  width: 100%;
  min-height: 300px;
  padding: 1.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  line-height: 1.5;
  font-family: inherit;
  color: #2c3948;
  resize: vertical;
}

.definition-besoin-textarea:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 2px rgba(218, 112, 39, 0.2);
}

/* Meme taille que "Reponse Technique au Besoin" (.definition-besoin-textarea). */
.critere-section textarea {
  width: 100%;
  min-height: 300px;
  padding: 1.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  line-height: 1.5;
  font-family: inherit;
  color: #2c3948;
  resize: vertical;
  margin-bottom: 0.5rem;
}

.critere-section textarea:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 2px rgba(218, 112, 39, 0.2);
}

/* Rendu lecture seule des reponses (reponse technique + 3 criteres) : la hauteur epouse le
   contenu (pas de min-height, pas de scroll), et \`pre-wrap\` conserve les retours a la ligne et
   les espaces saisis dans le textarea. Qualifie par \`.input-inactif\` pour reprendre son fond
   grise tout en foncant la couleur du texte (#6b7280 -> #2c3948), une offre devant se lire. */
.input-inactif.offre-reponse-lecture {
  color: #2c3948;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

/* --- Offre financiere : table de prix ------------------------------------- */
.articles-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1.5rem;
}

.articles-table tr {
  width: 100%;
  display: table;
  table-layout: fixed;
}

.articles-table th,
.articles-table td {
  padding: 0.8rem;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
}

.articles-table th {
  background-color: rgba(215, 217, 217, 0.1);
  font-weight: 600;
}

.financier-numero-article {
  width: 10%;
}

.financier-prix {
  width: 20%;
}

.prix-input-container {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
}

.prix-input {
  flex: 1 1;
  border: none;
  text-align: right;
  padding: 8px 4px;
  outline: none;
}

.prix-currency {
  background-color: #f5f5f5;
  padding: 8px 12px;
  color: #6b7280;
  display: block;
  white-space: nowrap;
}

.prix-error-cell {
  background-color: rgba(255, 0, 0, 0.05);
}

.prix-input.error {
  border: 1px solid #e63946 !important;
  background-color: #fff5f5;
}

.error-global-prix {
  margin-top: 12px;
  color: #e63946;
  background-color: #fff5f5;
  border: 1px solid #e63946;
  border-radius: 6px;
  padding: 10px 14px;
}

.total-row {
  font-weight: 700;
  font-size: 1.8rem;
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviDeCommandeMSV2/components/CommandeMsCandidature.css"],"names":[],"mappings":"AAAA;;;;+BAI+B;;AAE/B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;0DAC0D;AAC1D;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,iFAAiF;AACjF;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;;8FAG8F;AAC9F;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,+EAA+E;AAC/E;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":["/* Styles co-localises de l'onglet Candidature commande-MS (V2). Copie autonome (PAS un import)\n   des regles techniques/financieres de l'oracle Candidature.css : memes classes, memes valeurs,\n   pour une parite visuelle exacte. Les classes .section-header / .section-content / .form-group /\n   .input-inactif / .action-buttons / .error-message / .required / .page-break viennent du global\n   App.css (toujours charge). */\n\n.tab-candidature {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Bandeau d'expiration : encadre rouge proeminent (reproduit le style inline de l'oracle\n   Candidature.tsx:751-763, ici en classe co-localisee). */\n.tab-candidature .expired-notice {\n  background-color: #fee;\n  border: 2px solid #c33;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 24px;\n  color: #c33;\n  font-weight: bold;\n  text-align: center;\n}\n\n/* --- Descriptif technique : reponse + criteres ---------------------------- */\n.definition-besoin-textarea {\n  width: 100%;\n  min-height: 300px;\n  padding: 1.5rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.8rem;\n  line-height: 1.5;\n  font-family: inherit;\n  color: #2c3948;\n  resize: vertical;\n}\n\n.definition-besoin-textarea:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 2px rgba(218, 112, 39, 0.2);\n}\n\n/* Meme taille que \"Reponse Technique au Besoin\" (.definition-besoin-textarea). */\n.critere-section textarea {\n  width: 100%;\n  min-height: 300px;\n  padding: 1.5rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.8rem;\n  line-height: 1.5;\n  font-family: inherit;\n  color: #2c3948;\n  resize: vertical;\n  margin-bottom: 0.5rem;\n}\n\n.critere-section textarea:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 2px rgba(218, 112, 39, 0.2);\n}\n\n/* Rendu lecture seule des reponses (reponse technique + 3 criteres) : la hauteur epouse le\n   contenu (pas de min-height, pas de scroll), et `pre-wrap` conserve les retours a la ligne et\n   les espaces saisis dans le textarea. Qualifie par `.input-inactif` pour reprendre son fond\n   grise tout en foncant la couleur du texte (#6b7280 -> #2c3948), une offre devant se lire. */\n.input-inactif.offre-reponse-lecture {\n  color: #2c3948;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* --- Offre financiere : table de prix ------------------------------------- */\n.articles-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 1.5rem;\n}\n\n.articles-table tr {\n  width: 100%;\n  display: table;\n  table-layout: fixed;\n}\n\n.articles-table th,\n.articles-table td {\n  padding: 0.8rem;\n  text-align: left;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.articles-table th {\n  background-color: rgba(215, 217, 217, 0.1);\n  font-weight: 600;\n}\n\n.financier-numero-article {\n  width: 10%;\n}\n\n.financier-prix {\n  width: 20%;\n}\n\n.prix-input-container {\n  display: flex;\n  align-items: center;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  overflow: hidden;\n  width: 100%;\n}\n\n.prix-input {\n  flex: 1;\n  border: none;\n  text-align: right;\n  padding: 8px 4px;\n  outline: none;\n}\n\n.prix-currency {\n  background-color: #f5f5f5;\n  padding: 8px 12px;\n  color: #6b7280;\n  display: block;\n  white-space: nowrap;\n}\n\n.prix-error-cell {\n  background-color: rgba(255, 0, 0, 0.05);\n}\n\n.prix-input.error {\n  border: 1px solid #e63946 !important;\n  background-color: #fff5f5;\n}\n\n.error-global-prix {\n  margin-top: 12px;\n  color: #e63946;\n  background-color: #fff5f5;\n  border: 1px solid #e63946;\n  border-radius: 6px;\n  padding: 10px 14px;\n}\n\n.total-row {\n  font-weight: 700;\n  font-size: 1.8rem;\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
